import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import Image from '../../elements/Image';
import './Logo.css';

const Logo = ({
  className,
  ...props
}) => {

  const classes = classNames(
    'brand',
    className
  );

  return (
    <div
      {...props}
      className={classes}
    >
      <h1 className="m-0">
        <div className='div'>
        <Link to="/">
          <Image
            src={require('./../../../assets/images/gat200x2.png')}
            alt="Open"
            height={200}
          
             />
        </Link>
        </div>
      </h1>
    </div>
  );
}

export default Logo;